module.exports = __webpack_public_path__ + "static/media-header-1-ea857954077fa1c7b7cf9446bb2af139.jpg";